import React, { FC, useContext } from 'react';
import { Logo, SVGIcons } from '~/assets';
import { Image } from '~/components/Atoms';
import { ModalContext, ThemeContext } from '~/contexts';
import { LINKS } from '~/utils';
import {
  HeaderWrapper,
  IconButton,
  ImageWrapper,
  MenuItem,
  MenuItemWrapper,
  OptionsWrapper,
  Wrapper,
} from './styles';

type HamburguerMenuProps = {
  label: string;
  href: string;
};

type Props = {
  options?: HamburguerMenuProps[];
};

const HamburguerMenu: FC<Props> = ({ options = LINKS }) => {
  const { switchThemeChoice, themeChoice } = useContext(ThemeContext);
  const { setModalVisibility } = useContext(ModalContext);

  const iconChoiceTheme: SVGIconKeys = themeChoice === 'light' ? 'moon' : 'sun';

  const handleCloseClick = () => {
    setModalVisibility(false);
  };

  const handlePressSun = () => {
    switchThemeChoice();
  };

  return (
    <Wrapper>
      <HeaderWrapper>
        <IconButton onClick={handleCloseClick}>{SVGIcons.close()}</IconButton>
        <ImageWrapper>
          <Image src={Logo} alt="Logo" />
        </ImageWrapper>
        <IconButton onClick={handlePressSun}>
          {SVGIcons[iconChoiceTheme]()}
        </IconButton>
      </HeaderWrapper>
      <OptionsWrapper>
        {options.map(({ label, href }) => (
          <MenuItemWrapper key={`${label}${href}`}>
            <MenuItem href={href}>{label}</MenuItem>
          </MenuItemWrapper>
        ))}
      </OptionsWrapper>
    </Wrapper>
  );
};

export default HamburguerMenu;
